module.exports = __webpack_public_path__ + "media/images/delivery_Icon_white-8e0129a1b7824964a046c79f093717e8.png";